(ns app.front.view.attachment.select-list
  (:require [app.front.ui.table :as ui-table]
            [app.front.util :as futil :refer [for-all]]
            [app.front.view.attachment.common :as attachment-common]
            [app.front.view.attachment.list :as attachment-list]
            [app.front.view.workspace.subs :as ws-subs]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub]]
            [core.front.icons :as i]
            [core.util.util :as util]
            [potpuri.core :as p]
            [reagent.core :as r]))


(defn- is-pdf? [att]
  (->> (attachment-list/latest-file att)
       :attachment.version.file/content-type
       (= "application/pdf")))


(defn attachment-filename [att]
  (-> (attachment-list/latest-file att)
      :attachment.version.file/filename))

(defmulti sort-value
  "Extract the value to sort by, from
  `attr` (the selected attribute to sort on),
  `value` (the current row to extract the sort value for)"
  (fn [attr _] attr))

(defmethod sort-value :default [attr v]
  (get v attr))

(defmethod sort-value :attachment/types
  [_ v]
  (-> v :attachment/types first))


(defmethod sort-value :attachment.version.file/filename
  [_ v]
  (attachment-filename v))

(defn sort-value-from-ix-vector [index-vector rows v]
  (or (p/find-index index-vector (:db/id v))
      (count rows)))

(defn sort-rows [[attr descending?] index-vector rows]
  (let [sort-key-fn (if (= attr :verdict/index)
                      (partial sort-value-from-ix-vector index-vector rows)
                      (partial sort-value attr))]
    (if attr
      (sort-by sort-key-fn (if descending? > <) rows)
      rows)))


(defn remove-from-idx-vector [old-vector id]
  (let [idx            (p/find-index old-vector id)
        [before after] (split-at idx old-vector)]
    (vec (concat before (rest after)))))

(defn alter-idx-vector [old-vector id step]
  (let [idx            (+ (p/find-index old-vector id) step)
        [before after] (split-at idx (remove-from-idx-vector old-vector id))]
    (vec (concat before [id] after))))

(defn chevron-class [disabled?]
  (futil/cs "table-index-chevron"
            (when disabled? "disabled")))

(defn sort-col [{:keys [idx-vector tr id on-change editing?]}]
  (if-let [i (p/find-index idx-vector id)]
    (let [alter-idx-vector-by #(->> % (alter-idx-vector idx-vector id) on-change)]
      [:div.verdict-page__section__table-index
       [:span (inc i)]
       (when editing?
         [:<>
          (cc/icon {:icon        i/chevron-up
                    :class-name  (chevron-class (zero? i))
                    :description (tr [:move-up])
                    :on-click    (partial alter-idx-vector-by -1)})
          (cc/icon {:icon        i/chevron-down
                    :class-name  (chevron-class (= i (dec (count idx-vector))))
                    :description (tr [:move-down])
                    :on-click    (partial alter-idx-vector-by 1)})])])
    [:div]))

(defn select-list [{:keys [attachments idx-vector editing? on-change help-text]}]
  (r/with-let [*sorting    (r/atom [])]
    (let [select-all           (fn [checked?]
                                 (on-change
                                   (if checked?
                                     (->> (filter is-pdf? attachments)
                                          (map :db/id))
                                     [])))
          tr                   (<sub [:tr])
          selected-attachments (set idx-vector)]
      (when-let [attachments (->> attachments
                                  (sort-rows @*sorting idx-vector)
                                  not-empty)]
        [:div.verdict-page__section.verdict-page__attachments
         [:h4 (tr [:verdict/attachments])]
         (when help-text [:div.mb-2 help-text])
         #_{:clj-kondo/ignore [:deprecated-var]}
         [ui-table/table {}
          [[ui-table/table-header-checkbox "attachments-select-all" (tr [:select/all]) select-all (not editing?)]
           [ui-table/table-header-sortable tr *sorting :attachment/types]
           [ui-table/table-header-sortable tr *sorting :attachment.version.file/filename]
           [ui-table/table-header-sortable tr *sorting :attachment/contents]
           [ui-table/table-header-sortable tr *sorting :verdict/index]]
          (for-all [{:db/keys [id] :as att} attachments]
            {:key  (str id)
             :cols [{:content (cc/checkbox
                                {:id         (str id "-select")
                                 :label-text (tr [:select/select])
                                 :hide-label true
                                 :checked    (contains? selected-attachments id)
                                 :disabled   (or (not editing?)
                                                 (not (is-pdf? att)))
                                 :on-change  (fn [checked?]
                                               (on-change
                                                 (if checked?
                                                   (conj idx-vector id)
                                                   (remove-from-idx-vector idx-vector id))))})}
                    {:content (if (<sub [::ws-subs/loading-config?])
                                (cc/skeleton-text)
                                (attachment-common/attachment-types-text (:attachment/types att)))}
                    {:content [:<>
                               [:span (attachment-filename att)]
                               (when-not (is-pdf? att)
                                 [:span.verdict-page__mime-type-warning (tr [:verdict/attachment-warning])])]}
                    {:content (:attachment/contents att)}
                    {:content [sort-col (util/mmap idx-vector tr id on-change editing?)]}]})]]))))
